import React from 'react';
import FloatingLabelInputImpl from './FloatingLabelInputImpl.js';
import DSLabel from '../FormItem/Label/DSLabel.js';
import DSTextBox from '../TextBox/DSTextBox.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/getComponentFromProps';
import '@elliemae/ds-text-wrapper';
import 'resize-observer';
import './getSvgPath.js';
import '../RequiredMark/RequiredMark.js';
import 'prop-types';
import '@elliemae/ds-truncated-tooltip-text';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react-desc';
import '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import 'lodash';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';

var noop = function noop() {};

var DSFloatingLabelInput = function DSFloatingLabelInput(_ref) {
  _ref.containerProps;
      var _ref$arialLabel = _ref.arialLabel,
      arialLabel = _ref$arialLabel === void 0 ? '' : _ref$arialLabel,
      _ref$innerRef = _ref.innerRef,
      innerRef = _ref$innerRef === void 0 ? noop : _ref$innerRef,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$extraInputProps = _ref.extraInputProps,
      extraInputProps = _ref$extraInputProps === void 0 ? {} : _ref$extraInputProps,
      _ref$inputComponent = _ref.inputComponent,
      inputComponent = _ref$inputComponent === void 0 ? DSTextBox : _ref$inputComponent,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$labelComponent = _ref.labelComponent,
      labelComponent = _ref$labelComponent === void 0 ? DSLabel : _ref$labelComponent,
      _ref$labelText = _ref.labelText,
      labelText = _ref$labelText === void 0 ? null : _ref$labelText,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? false : _ref$optional,
      _ref$mask = _ref.mask,
      mask = _ref$mask === void 0 ? null : _ref$mask,
      _ref$useSubfix = _ref.useSubfix,
      useSubfix = _ref$useSubfix === void 0 ? '' : _ref$useSubfix;
  return /*#__PURE__*/React.createElement(FloatingLabelInputImpl, {
    arialLabel: arialLabel,
    className: className,
    disabled: disabled,
    extraInputProps: extraInputProps,
    hasError: hasError,
    innerRef: innerRef,
    inputComponent: inputComponent,
    isOpen: isOpen,
    labelComponent: labelComponent,
    labelText: labelText,
    mask: mask,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    optional: optional,
    readOnly: readOnly,
    required: required,
    useSubfix: useSubfix,
    value: value
  });
};

export default DSFloatingLabelInput;
//# sourceMappingURL=DSFloatingLabelInput.js.map
